<div class="{{class}}" [hidden]="hidden">
    <dx-check-box 
        id="checkbox-{{name}}"
        [value]="model"
        (onValueChanged)="modelChange.emit($event.value)"
        [text]="getLabel()"
        [readOnly]="disabled"
    ></dx-check-box>
</div>